// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2cteN","left":"styles_left__1nyvH"};